import { compactMoney } from '@/utilities/Money';
import { formatDate } from '@/utilities/Format';

// History diffs arrive as the API's strings, so a boolean override reads "true" / "false".
const yesNo = (val: string): string => (val === 'true' ? 'Yes' : val === 'false' ? 'No' : val);

export interface FieldLabel {
  label: string;
  formatter?: (val: string) => string;
}

// The stored No* flags are the inverse of the edit form's Applicable toggles.
const applicable = (val: string): string => (val === 'true' ? 'No' : 'Yes');

export const policyFieldLabels: Record<string, FieldLabel> = {
  peFlag: { label: 'Primary / Excess' },
  attachmentOverride: { label: 'Attachment', formatter: compactMoney },
  aggregateLimitOverride: { label: 'Aggregate Limit', formatter: compactMoney },
  occurrenceLimitOverride: { label: 'Occurrence Limit', formatter: compactMoney },
  quotaShareTotalOverride: { label: 'Total Layer Limit', formatter: compactMoney },
  retentionOverride: { label: 'Retention', formatter: compactMoney },
  noAttachment: { label: 'Attachment Applicable', formatter: applicable },
  noLimit: { label: 'Aggregate Limit Applicable', formatter: applicable },
  noOccurrenceLimit: { label: 'Occurrence Limit Applicable', formatter: applicable },
  noRetention: { label: 'Retention Applicable', formatter: applicable },
  policyPremiumOverride: { label: 'Premium Total', formatter: compactMoney },
  brokerOverride: { label: 'Broker' },
  sideAOverride: { label: 'Side A' },
  runoffOverride: { label: 'Runoff' },
  underwriterOverride: { label: 'Underwriter' },
  carrierOverride: { label: 'Carrier' },
  descriptionOverride: { label: 'Description' },
  policyNumberOverride: { label: 'Policy Number' },
  wholesalerOverride: { label: 'Wholesaler' },
  agencyNameOverride: { label: 'Agency' },
  coverageTypeOverride: { label: 'Coverage Type' },
  effectiveDateOverride: { label: 'Effective Date', formatter: formatDate },
  expirationDateOverride: { label: 'Expiration Date', formatter: formatDate },
  quotaShareOverride: { label: 'Quota Share', formatter: yesNo },
  syndicateId: { label: 'Lead Syndicate' },

  // Sublimit / subretention audit diffs, which the line history panel now merges in. sublimitID
  // and subretentionID are the item's own row id — they change only on an add or a removal, where
  // the name beside them already says what happened, so they are labelled rather than hidden.
  name: { label: 'Item' },
  limitValue: { label: 'Limit', formatter: compactMoney },
  retentionValue: { label: 'Retention', formatter: compactMoney },
  retentionBasis: { label: 'Basis' },
  sublimitID: { label: 'Sublimit record' },
  subretentionID: { label: 'Subretention record' },
};
